export const isProfileImcompletedError = (err) => {
  return err && err.detail === 'Os dados de perfil estão incompletos.';
};
